/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useState, useEffect } from 'react';

const showingInitially = (showFrom?: number, showUntil?: number): boolean => {
  const windowWidth = window.innerWidth;

  if (!showFrom && !showUntil) {
    return true;
  } else if (!showFrom) {
    // showUntil
    return showUntil! > windowWidth;
  } else if (!showUntil) {
    // showFrom
    return showFrom! < windowWidth;
  } else {
    // both
    return showUntil! > windowWidth && showFrom! < windowWidth;
  }
};

const HideableComponent = (props: {
  showFrom?: number;
  showUntil?: number;
  children?: React.ReactChild;
}): JSX.Element | null => {
  const mediaMinQuery = useState(
    props.showFrom ? window.matchMedia(`(min-width: ${props.showFrom}px)`) : null,
  )[0];
  const mediaMaxQuery = useState(
    props.showUntil ? window.matchMedia(`(max-width: ${props.showUntil}px)`) : null,
  )[0];
  const [visible, setVisible] = useState<boolean>(
    showingInitially(props.showFrom, props.showUntil),
  );

  const mediaQueryMinChanged = (ev: MediaQueryListEvent): void => {
    setVisible(ev.matches);
  };

  const mediaQueryMaxChanged = (ev: MediaQueryListEvent): void => {
    setVisible(ev.matches);
  };

  useEffect(() => {
    mediaMinQuery?.addListener(mediaQueryMinChanged);
    mediaMaxQuery?.addListener(mediaQueryMaxChanged);

    return () => {
      mediaMinQuery?.removeListener(mediaQueryMinChanged);
      mediaMaxQuery?.removeListener(mediaQueryMaxChanged);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (visible) {
    return <>{props.children}</>;
  } else {
    return null;
  }
};

export default HideableComponent;
